import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import config from 'utils/config';
import Stack from 'components/Stack';
import { splitContentItemsIntoSections, SECTION_TYPES } from './splitContentItemsIntoSections';
import Section from './Section';
function LegacyContentItemSections(_ref) {
  var playlist = _ref.playlist,
    onWebAssetClick = _ref.onWebAssetClick;
  var nextContentItemIndex = playlist.content.filter(function (a) {
    return a.type !== 'section';
  }).findIndex(function (a) {
    return a.userContentStatus !== 'completed' && a.optional === false;
  });
  var sections = splitContentItemsIntoSections(playlist.content);
  if (sections.length === 1) {
    return /*#__PURE__*/React.createElement(Section, {
      section: sections[0],
      playlist: playlist,
      nextContentItemIndex: nextContentItemIndex,
      onWebAssetClick: onWebAssetClick
    });
  }
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "l",
    as: config.playlistNumbering ? 'ordered-list' : 'list'
  }, sections.map(function (section, i) {
    return /*#__PURE__*/React.createElement(Section, {
      key: i,
      section: section,
      playlist: playlist,
      nextContentItemIndex: nextContentItemIndex,
      onWebAssetClick: onWebAssetClick
    });
  }));
}
export { SECTION_TYPES, splitContentItemsIntoSections };
export default LegacyContentItemSections;